const getAvatarColor = (name: string): string => {
  const colors = [
    'blue-lighten-4',
    'green-lighten-4',
    'orange-lighten-4',
    'deep-purple-lighten-4',
    'indigo-lighten-4',
    'teal-lighten-4',
    'cyan-lighten-4',
    'lime-lighten-5',
    'amber-lighten-5',
    'brown-lighten-5',
  ]
  return colors[name.length % colors.length]
}

const getInitials = (name: string): string =>
  name
    .split(' ')
    .map(n => n[0])
    .join('')
    .slice(0, 2)
    .toUpperCase()

export { getAvatarColor, getInitials }
